<style scoped>
table {
  font-family: arial, sans-serif;
  width: 100%;
}
table thead th{
  background: none !important;
  color: #3c4b64 !important;
}
td, th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}
.form-control {
  height: 100px !important;
}
.form-control:disabled, .form-control[readonly] {
  background-color: none !important;
  background: none !important;
}

.form-control:focus {
    background-color: #fff;
    border-color: none !important;
    outline: none !important;
    box-shadow: none !important;
}
.border-bottom.text-uppercase { 
  border-bottom: 2px solid #3c4b64 !important;
}
</style>
<template>
    <div class="row">
      <div class="my-3 d-flex ml-auto">
        <button class="btn btn-md btn-info mr-2" @click="generateReport">Download E-Kuitansi</button>
        <button @click="kembali" class="btn btn-md btn-dark">Kembali</button>          
      </div>
        <div class="col-lg-12 col-sm-12 col-12 px-0">
          <vue-html2pdf
              :show-layout="true"
              :float-layout="false"
              :enable-download="true" 
              :preview-modal="true"
              :paginate-elements-by-height="1400"
              :filename="'KUITANSI-' + this.items.no_kwitansi"
              :pdf-quality="2"
              :manual-pagination="false"
              :margin="1"
              pdf-format="a4"
              pdf-orientation="landscape"
              pdf-content-width=""
                @progress="onProgress($event)"
              @hasStartedGeneration="hasStartedGeneration()"
              @hasGenerated="hasGenerated($event)"
              ref="html2Pdf"
          >
              <section slot="pdf-content">
                  <div class="card card-body border-0 px-4">
                    <div class="row justify-content-between">
                      <div class="col-lg-9 col-sm-12 col-12">
                        <div class="row">
                          <div class="col-lg-5 col-sm-5 col-5 mb-2">
                            <img src="https://i.ibb.co/5xLhpFY/logo-iapi.gif" alt width="250" />
                          </div>
                        </div>
                        <p>
                          <b class="text-uppercase">Head Office : </b> 
                          Office 8 Building 12th Floor, Unit 12 I - 12 J
                          Sudirman Central Business District (SCBD) Lot 28 
                          <br>
                          Jl. Senopati Raya No. 88, Jakarta 12190, INDONESIA
                          <br>
                          Telp. (021) 293333151 72795445 - 46 (Hubungi), 08111707261 - 66 Fax : (021) 72795441, 72795449
                          <br>
                          <b class="text-uppercase">Back Office : </b>
                          Jl. Sampit II No. 15, Blok M - Kebayoran Baru, Jakarta Selatan 17130 INDONESIA
                          <br>
                          Telp. (021) 72795445 - 46 (Hubungi) Fax : (021) 72795441, 72795449
                        </p>
                      </div>

                      <div class="col-lg-3 col-sm-12 col-12 pl-xl-3 pl-sm-0 text-center">
                        <h3 class="border-bottom text-uppercase mx-3">
                          Kuitansi
                        </h3>
                        <span style="font-size:17px"> No. {{this.items.no_kwitansi ? this.items.no_kwitansi : '-'}}</span>
                      </div>
                    </div>

                    <div class="table-responsive mt-3">
                      <table class="table">
                        <thead class="text-grey">
                          <th scope="col">Sudah terima dari : </th>
                          <th scope="col" colspan="3" class="text-uppercase"> {{ items.atas_nama }} </th>
                        </thead>
                        <thead>
                          <th scope="col">No</th>
                          <th scope="col">Untuk Pembayaran</th>
                          <th scope="col">Jumlah Uang</th>
                          <th scope="col" class="pr-5 text-sm-right">Tanggal Transaksi</th>
                        </thead>
                        <tbody>
                          <tr v-for="(value, index) in dataPayment" :key="index">
                            <td>{{ index+1 }}</td>
                            <td>{{ value.namaItem }}</td>

                            <td scope="row">Rp. {{ formatPrice(value.nominal) ? formatPrice(value.nominal) : '0' }}</td>
                            <td scope="row" class="pr-5 text-sm-right">
                              <span class="pr-4">{{ value.created_at ? value.created_at : '-' }}</span>
                            </td>
                          </tr>
                        </tbody>
                        <tbody>
                          <tr>
                            <td colspan="2">Total Pembayaran</td>
                            <td colspan="2" clas="font-weight-bold currency" id="currency">Rp. {{formatPrice(items.nominal) ? formatPrice(items.nominal) : '0'}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="row justify-content-between align-items-center mt-3">
                      <div class="col-md-8">
                        <!-- <p class="h6">
                          <i>Terbilang : </i>
                          <b class="ml-3 text-uppercase" id="calculated">Dua Juta Delapan Ratur Ribu Rupiah</b>
                        </p> -->
                      </div>
                      <div class="col-md-4">
                        <label for="">Jakarta, {{ tanggal_pembayaran }}</label>
                          <div class="form-group">
                            <input type="text" class="form-control" readonly>
                          </div>
                      </div>   
                    </div>
                  </div>
              </section>
          </vue-html2pdf>
      </div>
    </div>
</template>
<script>
import PaymentService from '@/services/finance/payment.service'
import VueHtml2pdf from 'vue-html2pdf'
import moment from 'moment'
export default {
  data() {
    return {
      items: {},
      dataPayment: {},
      hasStartedGeneration: false,
      myDate: null,
      tanggal_pembayaran: ""
    }
  },

  mounted() {
    this.getData()
    localStorage.getItem('filterPembayaran')
  },

  methods: {
    kembali() {
      if(this.$route.query.statusfilter != undefined) {
        this.$router.push({path:'/keuangan/pembayaran/sertifikasi-rpl',query: { 
          periode : this.$route.query.periode,
          nama_rpl : this.$route.query.nama_rpl,
          id_sertifikasi_rpl : this.$route.query.id_sertifikasi_rpl,
          statusfilter : this.$route.query.statusfilter,
        } })
      } else {
        this.$router.push({path:'/keuangan/pembayaran/sertifikasi-rpl'});
      }
      // alert("kembali")
    },
    moment() {
      moment().format('MMMM Do YYYY, h:mm:ss a');
    },
    formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    generateReport () {
      this.$refs.html2Pdf.generatePdf()
    },
    getData() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      var vm = this;
      PaymentService.getInvoice(this.$route.params.id_invoice)
        .then(response => {
          loader.hide();
          vm.items = response.data.singleData;
          vm.dataPayment = response.data.singleData.item_payment
          vm.tanggal_pembayaran = response.data.singleData.tanggal_pembayaran ? moment(response.data.singleData.tanggal_pembayaran).locale('Id').format('DD MMMM YYYY') : "-"
        })
        .catch(error => {
          // comment console console.log(error);
          loader.hide();
        });
    },
  }
}
</script>